import { useRestaurant } from '@/hooks/useRestaurant';

interface RestaurantTitleSuffixProps {
  restaurantId: number;
}

/**
 * Renders ` · {Restaurant Name}` to sit beside a page title on restaurant-scoped
 * pages. Renders nothing until the name is loaded, so there's no layout flash.
 */
export function RestaurantTitleSuffix({ restaurantId }: RestaurantTitleSuffixProps) {
  const { data } = useRestaurant(restaurantId);
  if (!data?.name) return null;
  return <span className="font-semibold text-blue-800"> · {data.name}</span>;
}
